export default {
  form: {
    bank_account_number: {
      label: 'Número de cuenta',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Número de ruta',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'País',
      placeholder: 'Alemania',
    },
    bank_statement_descriptor: {
      label: 'Descriptor del extracto',
      placeholder: 'Nombre del restaurante',
      tooltip: 'Este nombre aparecerá en los extractos bancarios de los clientes',
    },
  },
  buttons: {
    next: 'Siguiente',
    back: 'Atrás',
    use_test_data: 'Usar datos de prueba',
  },
  test_data_hint: 'Cuenta bancaria de prueba aceptada por {{gateways}}',
  read_only_warning:
    'La información bancaria solo puede ser modificada por nuestro equipo. Si necesita actualizarla, contacte con soporte.',
};
